import { createAction } from '@ngrx/store';

export const exportSamplesSSA = createAction(
    '[Samples/ExportSamples] Export samples as Excel file'
);
